import {
  ACTION_GET_FEATURES,
  ACTION_GET_FEATURES_SUCCESS,
  ACTION_GET_FEATURES_FAILURE,
  ACTION_EMPTY_FEATURES,
  ACTION_RESET_FEATURES,
  API_CALL,
} from '../../configs/ActionTypes';

import * as _ from 'lodash-es';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export type Params = {
  id?: string;
  scopeType?: string;
};

export function getFeatures(params: Params) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'features',
        method: 'get',
        data: params || {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_FEATURES,
    payload: null,
  };
}

export function emptyResults() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_FEATURES,
      payload: null,
    });
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_FEATURES_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_FEATURES_FAILURE,
    payload: responseJSON,
  };
}

export function resetFeatures() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: ACTION_RESET_FEATURES,
      payload: null,
    });
  };
}
